import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//styles
import { Wrapper } from './styles';

const MyDatePicker = ({ name, size = 20, width, value = null, isDisabled, onChange, classes }) => {
  return (
    <Wrapper
      size={size}
      width={width}
      className={classes}>
        <DatePicker selected={value} onChange={onChange} />
    </Wrapper>
  );
};

export default MyDatePicker;
